import React, { useState, useCallback } from 'react'
import { useQuery } from 'components/graphql'
import initQuery from './initQuery'
import { INIT_QUERY_PARAMS } from 'config/consts'
import { InitialLoading } from 'components/Loading'
import { AlertModal } from 'components/Modal'
import { isEmpty } from 'lodash'

const withRouteParams = (rights) => {
	const initialRouteParams = {
		withProduct: { value: true, label: 3 },
		withTemplate: { value: true, label: 4 },
		withEmployee: { value: true, label: 5 },
		withMediaCenter: { value: true, label: 6 },
		withCustomersCredit: { value: true, label: 12 },
		withDebitCard: { value: true, label: 13 }
	}
	const getPayload = () => {
		return Object.keys(initialRouteParams).reduce((acc, key) => ({ ...acc, [key]: initialRouteParams[key].value }), {})
	}
	const parsedRights = JSON.parse(rights || null)?.caw
	if (isEmpty(parsedRights)) {
		return getPayload()
	}

	for (const right of parsedRights) {
		const splitted = right.split(',')
		const section = +splitted[0]
		const accessBit = +splitted[1]
		for (const key in initialRouteParams) {
			if (!accessBit && initialRouteParams[key].label === section) {
				initialRouteParams[key].value = false
			}
		}
	}

	return getPayload()
}

const withInitQuery = Component => props => {
	const accessCustomRights = props?.authData?.attributes?.['custom:access_custom_rights']
	const queryVars = { ...INIT_QUERY_PARAMS, ...withRouteParams(accessCustomRights) }

	const { data, loading, error, hasData } = useQuery(initQuery, {
		variables: queryVars,
		fetchPolicy: 'cache-first',
		onError: () => triggerModal()
	})

	const [modalVisible, setModalState] = useState(false)
	const triggerModal = useCallback(() => {
		setModalState(prevState => !prevState)
	})

	if (error) {
		const { message } = error
		return (
			modalVisible && <AlertModal
				width={340}
				text={message}
				onClose={triggerModal}
				showBtn
			/>
		)
	}

	return hasData
		? <Component {...props} initData={data} initDataReady={!loading && Object.keys(data).length} />
		: <InitialLoading />
}

export default withInitQuery
